<app-centered-page-wrapper>
  <h1>Forgot Password</h1>

  <p *ngIf="sent; else content">
    Password reset email sent successfully. Please check your email.
    <br>
    <br> If you don't see the email, check other places it might be, like your junk, spam, or other folders.
    <a routerLink="/login" class="d-block mt-3">
      <button class="btn btn-primary">
        RETURN TO LOGIN
      </button>
    </a>
  </p>

  <ng-template #content>
    <p>Enter your email address and we'll send you an email that will allow you to reset your password.</p>
    <div class="form-group">
      <input class="form-control" [(ngModel)]="email" id="email" name="email" required placeholder="Enter email address..." (keyup.enter)="sendEmail()">
    </div>
    <button class="btn btn-primary" (click)="sendEmail()" disabled="{{ sending }}">
      <app-loading-spinner *ngIf="sending" [text]="'SENDING...'"></app-loading-spinner>
      <ng-container *ngIf="!sending">SEND</ng-container>
    </button>
    <a routerLink="/login">
      <button class="btn btn-light ml-2">LOG IN</button>
    </a>
  </ng-template>

</app-centered-page-wrapper>
